// 社群管家
import robot from './modules/robot'
// 采编发
import cep from './modules/cep'
// 信息工作台
import workbench from './modules/workbench'
// 大数据
import insight from './modules/insight'
// 用户管理
import user from './modules/user'
// 融媒管家
import rmplus from './modules/rmplus'
// 小程序
import mp from './modules/mp'
// 新闻宣传
import interview from './modules/interview'
// 申请审批
import apply from './modules/apply'
import topic from './modules/topic'
import cloud from './modules/cloud'
import submit from './modules/submit'
import spread from './modules/spread'
import tyc from './modules/tyc'
import yq from './modules/yq'
import group from './modules/group'
import mobile from './modules/mobile'

// 媒资库
import mediadata from './modules/mediadata'

// 系统设置
import system from './modules/system'

// 菜单 侧边栏
export default [
  workbench,
  insight,
  tyc,
  topic,
  cep,
  //cloud,
  spread,
  yq,
  //group,
  rmplus,
  user,
  mobile,
  submit,
  apply,
  // interview,
  robot,
  //mediadata,
  system
]
